import { getEnvBoolean, getEnvString } from 'src/utils'
import type { Region } from './schema'

export function getBackendByRegion(region?: Region | null) {
  const bypassRegion = getEnvBoolean('REACT_APP_BYPASS_REGION', false)

  if (bypassRegion || !region) {
    return getEnvString('REACT_APP_SERVER_HOST')
  }

  const backendUrl = new URL(getEnvString('REACT_APP_SERVER_HOST'))
  return new URL(`${backendUrl.protocol}//${region}.${backendUrl.host}`).href
}
